<template>
  <div class="main_box meeting_box">
    <h2 class="hidden-md-and-up">会议/活动</h2>
    <div class="meeting_list_box" v-if="isInit && !hasMeeting">
      <div class="meeting_list_create_box">
        <div class="meeting_list_create">
          <el-link
            type="primary"
            @click="openCreateMeetingModal(-1)"
            v-if="userRole === 2 || userRole === 3"
            icon="el-icon-circle-plus-outline"
          >
            创建
          </el-link>
        </div>
        <div>请先创建会议/活动，再发起投票、问卷</div>
        <br />
        <h3>适用于多种场景</h3>
        <div>职称评定、项目评优、代表选举、评选先进</div>
        <div>题库考试、调查问卷、表单登记、评估测评</div>
      </div>
    </div>
    <div class="meeting_list_box" v-if="isInit && hasMeeting">
      <el-tabs v-model="activeName" @tab-click="tabClick" v-show="false">
        <el-tab-pane
          label="全部"
          name="all"
          :disabled="meetingListLoading"
        ></el-tab-pane>
        <el-tab-pane
          label="编辑中"
          name="edit"
          :disabled="meetingListLoading"
        ></el-tab-pane>
        <el-tab-pane
          label="已发布"
          name="publish"
          :disabled="meetingListLoading"
        ></el-tab-pane>
        <el-tab-pane
          label="已结束"
          name="end"
          :disabled="meetingListLoading"
        ></el-tab-pane>
        <el-tab-pane
          label="已归档"
          name="close"
          :disabled="meetingListLoading"
        ></el-tab-pane>
      </el-tabs>
      <el-row>
        <el-col
          :xs="{ span: 24, offset: 0 }"
          :sm="{ span: 16, offset: 4 }"
          :md="{ span: 14, offset: 5 }"
          :lg="{ span: 12, offset: 6 }"
          :xl="{ span: 10, offset: 7 }"
        >
          <div class="meeting_list_search">
            <el-input
              placeholder="请输入检索内容"
              v-model="meetingListQuery.keyWord"
              prefix-icon="el-icon-search"
              class="meeting_list_search_input"
              clearable
            >
              <el-button slot="append" @click="searchClick">查询</el-button>
            </el-input>
            <el-button
              type="primary"
              @click="openCreateMeetingModal(-1)"
              v-if="userRole === 2 || userRole === 3"
            >
              创建
              <i class="el-icon-circle-plus-outline el-icon--right"></i>
            </el-button>
          </div>
        </el-col>
      </el-row>
      <el-table
        :data="meetingTableData"
        style="width: 100%"
        :height="tableHeight"
      >
        <el-table-column
          label="名称"
          min-width="200"
          label-class-name="el_table_important_column"
        >
          <template slot-scope="scope">
            <span
              class="iconfont icon-huiyi3-copy"
              v-if="scope.row.MeetingType === 0"
              style="color: #0093cb"
            ></span>
            <span
              class="iconfont icon-qa1"
              v-if="scope.row.MeetingType === 1"
              style="color: #e74c3f"
            ></span>
            <span
              class="iconfont icon-toupiaoguanli"
              v-if="scope.row.MeetingType === 2"
              style="color: #e74c3f"
            ></span>
            <el-link
              v-html="scope.row.MeetingName"
              @click="getIntoItemClick(scope.row)"
            >
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <span class="span_tip" :class="scope.row.StateFont">
              {{ scope.row.StrState }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="时间" width="190" align="center" v-if="!is_xs">
          <template slot-scope="scope">
            <span>
              开始时间：{{
                scope.row.StartTime | dateformat('YYYY.MM.DD HH:mm')
              }}
              <br />
              结束时间：{{ scope.row.EndTime | dateformat('YYYY.MM.DD HH:mm') }}
              <br />
              {{ scope.row.CompanyName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="投票数"
          width="60"
          align="center"
          v-if="is_lg || is_xl"
        >
          <template slot-scope="scope">
            <span v-show="scope.row.MeetingType === 0">
              {{ scope.row.VoteNum ? scope.row.VoteNum : 0 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="315"
          header-align="center"
          align="left"
          v-if="!is_xs"
        >
          <template slot-scope="scope">
            <div class="meeting_list_btn_box">
              <el-button
                type="primary"
                size="mini"
                @click="getIntoItemClick(scope.row)"
                plain
              >
                进入{{ scope.row.MeetingTypeText }}
              </el-button>
              <el-button
                type="primary"
                size="mini"
                v-show="scope.row.State == 1 || scope.row.State == 3"
                @click="meetingPublish(scope.$index, scope.row)"
                plain
              >
                开始
              </el-button>
              <el-button
                type="primary"
                size="mini"
                v-show="scope.row.State == 4"
                @click="meetingCloseRelease(scope.$index, scope.row)"
                plain
              >
                结束
              </el-button>
              <el-button
                type="primary"
                size="mini"
                v-show="scope.row.State == 3 && scope.row.MeetingType !== 2"
                @click="meetingClose(scope.$index, scope.row)"
                plain
              >
                归档
              </el-button>
              <el-button
                type="success"
                size="mini"
                v-show="scope.row.State == 1 && scope.row.MeetingType !== 2"
                @click="openEditVote(scope.row.MeetingID)"
                plain
              >
                编辑
              </el-button>
              <el-button
                type="success"
                size="mini"
                v-show="scope.row.State == 1"
                @click="deleteMeeting(scope.$index, scope.row)"
                plain
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label=""
          width="85"
          header-align="center"
          align="left"
          v-if="is_lg || is_xl"
        >
          <template slot-scope="scope">
            <div class="meeting_list_btn_box">
              <el-button
                title="小程序二维码"
                type="text"
                size="mini"
                @click="onShowWXCode(scope.row)"
                icon="iconfont icon-xiaochengxu"
                circle
              >
              </el-button>
              <el-button
                title="二维码"
                type="text"
                size="mini"
                @click="onShowCode(scope.row)"
                icon="iconfont icon-erweima"
                circle
              >
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="meetingListQuery.maxResultCount"
        :layout="pagination_layout"
        :total="meetingListNumber"
      >
      </el-pagination>
    </div>
    <el-image-viewer
      v-if="showCode"
      :on-close="closeCode"
      :url-list="MeetingCodeUrl"
    />
    <el-dialog
      :title="'创建' + typeTitle"
      :visible.sync="dialogCreateVisible"
      custom-class="custom_dialog"
      :close-on-click-modal="false"
      top="10vh"
    >
      <div class="create_meeting_select_box" v-show="!isShowCreateFrom">
        <a class="create_meeting_select_btn" @click="openCreateMeetingModal(0)">
          <i class="iconfont icon-huiyi3-copy"></i>
          <H3>创建会议</H3>
          <span>职称评定·项目评优·代表选举·评选先进</span>
        </a>
        <a class="create_meeting_select_btn" @click="openCreateMeetingModal(1)">
          <i class="iconfont icon-qa1"></i>
          <H3>创建活动</H3>
          <span>题库考试·调查问卷·表单登记·评估测评</span>
        </a>
      </div>
      <div class="create_meeting_from_box" v-show="isShowCreateFrom">
        <el-form
          :model="createMeetingForm"
          :rules="createMeetingFormRules"
          ref="createMeetingForm"
          label-width="130px"
          class="demo-ruleForm"
          :label-position="is_xs ? 'top' : 'right'"
        >
          <el-form-item label="类型：" prop="MeetingType">
            <el-radio-group
              v-model="createMeetingForm.MeetingType"
              size="medium"
              @change="meetingTypeChange()"
            >
              <el-radio-button :label="0" v-show="$config.enableVote">
                <i class="iconfont icon-huiyi3-copy"></i>
                会议投票
              </el-radio-button>
              <el-radio-button :label="2" v-show="$config.enableVote">
                <i class="iconfont icon-toupiaoguanli"></i>
                活动投票
              </el-radio-button>
              <el-radio-button :label="1" v-show="$config.enableWJ">
                <i class="iconfont icon-qa1"></i>
                考试问卷
              </el-radio-button>
            </el-radio-group>
            <div class="form_item_info">
              <div v-show="$config.enableVote">
                会议投票：职称评定、项目评优、代表选举、评选先进、分数排名、投屏评定
              </div>
              <div v-show="$config.enableVote">
                网络投票：匿名评选、网络投票
              </div>
              <div v-show="$config.enableWJ">
                考试问卷：题库考试、调查问卷、表单登记、评估测评
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="typeTitle + '名称：'" prop="MeetingName">
            <el-input
              ref="MeetingName"
              v-model="createMeetingForm.MeetingName"
            ></el-input>
            <span
              style="color: red; font-size: 12px"
              v-if="
                createMeetingForm.MeetingType === 0 ||
                createMeetingForm.MeetingType === 1
              "
            >
              提示：{{ typeTitle }}开启后，名称将不能修改，请在{{
                typeTitle
              }}开启前进行确认。
            </span>
          </el-form-item>
          <el-form-item :label="typeTitle + '时间：'" required>
            <el-col :span="11">
              <el-form-item class="el-form-item-internal" prop="StartTime">
                <el-date-picker
                  ref="StartTime"
                  type="datetime"
                  v-model="createMeetingForm.StartTime"
                  placeholder="选择开始日期时间"
                  format="yyyy-MM-dd HH:mm"
                  default-time="9:00:00"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item class="el-form-item-internal" prop="EndTime">
                <el-date-picker
                  ref="EndTime"
                  type="datetime"
                  placeholder="选择结束日期时间"
                  format="yyyy-MM-dd HH:mm"
                  v-model="createMeetingForm.EndTime"
                  default-time="18:00:00"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            label="联系人："
            prop="ContactPeople"
            v-if="createMeetingForm.MeetingType === 1"
          >
            <el-input
              ref="ContactPeople"
              v-model="createMeetingForm.ContactPeople"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系电话："
            prop="ContactPhone"
            v-if="createMeetingForm.MeetingType === 1"
          >
            <el-input
              ref="ContactPhone"
              v-model="createMeetingForm.ContactPhone"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="typeTitle + '地址：'"
            prop="Address"
            v-if="
              createMeetingForm.MeetingType === 0 ||
              createMeetingForm.MeetingType === 1
            "
          >
            <el-input
              ref="Address"
              v-model="createMeetingForm.Address"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="类型" prop="MeetingType">
            <el-select
              v-model="createMeetingForm.MeetingType"
              placeholder="请选择类型"
            >
              <el-option
                v-for="meetingType in meetingTypes"
                :key="meetingType.DictionaryID"
                :label="meetingType.DictionaryName"
                :value="meetingType.DictionaryID"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item
            label="仅统计发票信息："
            v-show="createMeetingForm.MeetingType === 0"
          >
            <el-switch v-model="createMeetingForm.IsOnlyInvoice"> </el-switch>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="form_item_info">
                <i class="el-icon-warning-outline"></i>
                开启后只用作收集开票信息
              </div>
            </el-col>
          </el-form-item>
          <el-form-item
            label="仅收集参会回执："
            v-show="createMeetingForm.MeetingType === 0"
          >
            <el-switch v-model="createMeetingForm.IsMeetingReceipt">
            </el-switch>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="form_item_info">
                <i class="el-icon-warning-outline"></i>
                开启后只用作收集参会回执信息
              </div>
            </el-col>
          </el-form-item>
          <el-form-item
            label="请选择回执步骤："
            v-show="
              createMeetingForm.MeetingType === 0 &&
              createMeetingForm.IsMeetingReceipt
            "
          >
            <el-select v-model="createMeetingForm.MeetingReceiptState">
              <el-option label="活动未开始" :value="0"> </el-option>
              <el-option label="填写报名" :value="1"> </el-option>
              <el-option label="报名结束" :value="2"> </el-option>
              <el-option label="进入签到" :value="3"> </el-option>
              <el-option label="签到结束" :value="4"> </el-option>
              <el-option label="活动结束" :value="5"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="开启观摩："
            v-show="createMeetingForm.MeetingType === 0"
          >
            <el-switch v-model="createMeetingForm.IsAllowTrack"> </el-switch>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="form_item_info">
                <i class="el-icon-warning-outline"></i>
                开启开关可以观摩投票（不能参与投票）；也可以在投票人员中添加“监票人”，“监票人”登录后进行观摩。
              </div>
            </el-col>
          </el-form-item>
          <el-form-item
            label="是否匿名："
            v-if="
              createMeetingForm.MeetingType === 0 ||
              createMeetingForm.MeetingType === 1
            "
          >
            <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
              <el-form-item class="el-form-item-internal" prop="Verify">
                <el-switch
                  v-model="createMeetingForm.Verify"
                  @change="meetingVerifyChange()"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item class="el-form-item-internal" prop="IsEveryDay">
                <el-checkbox
                  v-model="createMeetingForm.IsEveryDay"
                  :disabled="!createMeetingForm.Verify"
                >
                  是否每天可投票
                </el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="form_item_info">
                <i class="el-icon-warning-outline"></i>
                开启匿名后，评委仅需扫码即可进行投票，不需要登录；开启每天可投票，用户每天都可投一次票。
              </div>
            </el-col>
          </el-form-item>
          <el-form-item
            label="是否每天投票："
            v-if="createMeetingForm.MeetingType === 2"
          >
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item class="el-form-item-internal" prop="IsEveryDay">
                <el-switch v-model="createMeetingForm.IsEveryDay"> </el-switch>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="form_item_info">
                <i class="el-icon-warning-outline"></i>
                开启每天投票，用户每天都可投一次票。
              </div>
            </el-col>
          </el-form-item>
          <el-form-item
            label="报名签到："
            v-if="
              createMeetingForm.MeetingType === 0 ||
              createMeetingForm.MeetingType === 1
            "
          >
            <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
              <el-form-item
                class="el-form-item-internal"
                prop="IsVoteUserApply"
              >
                <el-switch v-model="createMeetingForm.IsVoteUserApply">
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item class="el-form-item-internal" prop="IsGoApply">
                <el-checkbox
                  v-model="createMeetingForm.IsGoApply"
                  :disabled="!createMeetingForm.IsVoteUserApply"
                >
                  扫码是否首先进入报名签到页面
                </el-checkbox>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            label="报名签到文本："
            prop="ApplyButtonText"
            v-if="
              createMeetingForm.MeetingType === 0 ||
              createMeetingForm.MeetingType === 1
            "
          >
            <el-input
              ref="ApplyButtonText"
              v-model="createMeetingForm.ApplyButtonText"
              :disabled="!createMeetingForm.IsVoteUserApply"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="报名截止时间："
            prop="ApplyDeadlineTime"
            v-if="
              createMeetingForm.MeetingType === 0 ||
              createMeetingForm.MeetingType === 1
            "
          >
            <el-date-picker
              type="datetime"
              placeholder="选择截止时间"
              format="yyyy-MM-dd HH:mm"
              v-model="createMeetingForm.ApplyDeadlineTime"
              style="width: 100%"
              :disabled="!createMeetingForm.IsVoteUserApply"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="提示信息标题："
            prop="TipsTitle"
            v-if="
              createMeetingForm.MeetingType === 0 ||
              createMeetingForm.MeetingType === 1
            "
          >
            <el-input
              ref="TipsTitle"
              v-model="createMeetingForm.TipsTitle"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="提示信息内容："
            prop="TipsContent"
            v-if="
              createMeetingForm.MeetingType === 0 ||
              createMeetingForm.MeetingType === 1
            "
          >
            <!-- <quill-editor
              v-model="createMeetingForm.TipsContent"
              ref="contentQuillEditor"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @change="onEditorChange($event)"
              @ready="onEditorReady($event)"
            >
            </quill-editor> -->
            <VueUeditorWrap
              ref="TipsContent"
              v-model="createMeetingForm.TipsContent"
              :config="ueditorConfig"
            ></VueUeditorWrap>
          </el-form-item>
          <el-form-item
            :label="typeTitle + '简介：'"
            prop="Contents"
            v-if="
              createMeetingForm.MeetingType === 0 ||
              createMeetingForm.MeetingType === 1
            "
          >
            <el-input
              ref="Contents"
              type="textarea"
              v-model="createMeetingForm.Contents"
            ></el-input>
          </el-form-item>
          <el-form-item label="直接发布" prop="State" v-if="false">
            <el-switch
              v-model="createMeetingForm.State"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="4"
              :inactive-value="1"
            >
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogCreateVisible = false">
          取消
        </el-button>
        <el-button
          type="primary"
          size="medium"
          @click="addMeeting('createMeetingForm')"
          v-show="isShowCreateFrom"
        >
          创建
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入组件
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
// import { quillEditor, Quill } from 'vue-quill-editor' // 调用编辑器
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
// import { addQuillTitle } from '../../../assets/js/quill-title'
import ueditorConfig from '../../../assets/js/ueditorConfig'
import VueUeditorWrap from 'vue-ueditor-wrap'
import voteManageApi from '../../../api/vote/voteManage' // voteManage投票管理接口
export default {
  name: 'Home',
  components: {
    ElImageViewer,
    // quillEditor,
    VueUeditorWrap
  },
  inject: ['mainHeadGetMeetingList'],
  data () {
    const phoneReg = /(^(\d{2,4}[-_－—]?)?\d{3,8}([-_－—]?\d{3,8})?([-_－—]?\d{1,7})?$)|(^0?1[35]\d{9}$)/
    const validatePhone = (rule, value, callback) => {
      if (!phoneReg.test(value)) {
        callback(new Error('电话号码格式不正确'))
      } else {
        callback()
      }
    }
    return {
      activeName: 'all',
      isFirstQuery: true,
      meetingListLoading: true,
      meetingListNumber: 0,
      meetingListQuery: {
        keyWord: '',
        meetingState: null,
        maxResultCount: 10,
        skipCount: 0
      },
      meetingTableData: [],
      showCode: false,
      MeetingCodeUrl: [],
      dialogCreateVisible: false,
      isShowCreateFrom: false,
      createActivityDisable: true,
      typeTitle: '会议/活动',
      // meetingTypes: [],
      createMeetingForm: {
        MeetingName: '',
        StartTime: '',
        EndTime: '',
        MeetingType: 0,
        Address: '',
        Contents: '',
        State: 4,
        IsVoteUserApply: false,
        ApplyDeadlineTime: '',
        IsGoApply: false,
        ApplyButtonText: '',
        TipsTitle: '',
        TipsContent: '',
        Verify: false,
        IsEveryDay: false,
        IsAllowTrack: false,
        IsOnlyInvoice: false,
        IsMeetingReceipt: false,
        MeetingReceiptState: 0,
        ContactPeople: '',
        ContactPhone: ''
      },
      createMeetingFormRules: {
        MeetingName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }],
        StartTime: [{ type: 'date', required: true, message: '请选择开始日期时间', trigger: 'change' }],
        EndTime: [{ type: 'date', required: true, message: '请选择结束日期时间', trigger: 'change' }],
        // MeetingType: [
        //   { required: true, message: '请选择类型', trigger: 'change' }
        // ],
        Address: [
          { max: 500, message: '长度在 500 个字符以内', trigger: 'blur' }
        ],
        Contents: [
          { max: 4000, message: '长度在 4000 个字符以内', trigger: 'blur' }
        ],
        ApplyButtonText: [
          { max: 20, message: '长度在 20 个字符以内', trigger: 'blur' }
        ],
        TipsTitle: [
          { max: 100, message: '长度在 100 个字符以内', trigger: 'blur' }
        ],
        ContactPeople: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 200 个字符', trigger: 'blur' }],
        ContactPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 30 个字符', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }]
      },
      userRole: -1,
      isInit: false,
      hasMeeting: false,
      pagination_layout: 'prev, pager, next',
      currentPage: 1,
      tableHeight: window.innerHeight - 205,
      //   editorOption: {
      //     theme: 'snow',
      //     placeholder: '请输入...',
      //     modules: {
      //       // 工具栏设置
      //       toolbar: {
      //         container: [
      //           ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
      //           // ['blockquote', 'code-block'], // 引用，代码块
      //           // [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
      //           [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
      //           [{ script: 'sub' }, { script: 'super' }], // 上下标
      //           [{ indent: '-1' }, { indent: '+1' }], // 缩进
      //           [{ align: [] }], // 对齐方式
      //           [{ direction: 'rtl' }], // 文本方向
      //           [{ size: ['12px', '14px', '16px', '20px', '24px', '36px'] }], // 字体大小
      //           [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
      //           [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
      //           [{ font: ['sans serif', 'SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial'] }], // 字体
      //           ['link', 'image', 'video'], // 上传图片、上传视频
      //           ['clean'] // 清除字体样式
      //         ],
      //         handlers: {
      //         }
      //       }
      //     }
      //   },
      ueditorConfig: ueditorConfig
    }
  },
  methods: {
    tabClick (tab, event) {
      this.meetingListQuery.skipCount = 0
      this.meetingListLoading = true
      this.openLoading()
      this.meetingTableData = []
      switch (tab.name) {
        case 'all':
          this.meetingListQuery.meetingState = null
          this.getMeetingList()
          break
        case 'edit':
          this.meetingListQuery.meetingState = 1
          this.getMeetingList()
          break
        case 'publish':
          this.meetingListQuery.meetingState = 4
          this.getMeetingList()
          break
        case 'end':
          this.meetingListQuery.meetingState = 3
          this.getMeetingList()
          break
        case 'close':
          this.meetingListQuery.meetingState = 6
          this.getMeetingList()
          break
        default:
          this.activeName = 'all'
          break
      }
    },
    searchClick: function () {
      this.meetingListLoading = true
      this.openLoading()
      this.meetingListQuery.skipCount = 0
      this.meetingTableData = []
      this.getMeetingList()
    },
    makeMeetingInfo: function (item) {
      switch (item.State) {
        case 1:
          item.StateFont = 'draft_bg_color'
          break
        case 3:
          item.StateFont = 'end_bg_color'
          break
        case 4:
          item.StateFont = 'publish_bg_color'
          break
        case 6:
          item.StateFont = 'close_bg_color'
          break
      }
    },
    getMeetingList: function () {
      // this.openLoading()
      this.$api.meetingManage.getMeetingList({
        keyWord: this.meetingListQuery.keyWord,
        meetingState: this.meetingListQuery.meetingState,
        skipCount: this.meetingListQuery.skipCount,
        maxResultCount: this.meetingListQuery.maxResultCount
      }).then(data => {
        this.isInit = true
        this.meetingTableData = data.Items
        if (this.meetingTableData) {
          this.meetingTableData.forEach(item => {
            this.makeMeetingInfo(item)
          })
        }
        this.meetingListNumber = data.TotalCount
        if (this.isFirstQuery) {
          this.isFirstQuery = false
        }
        if (this.meetingTableData.length > 0 || this.meetingListQuery.keyWord) {
          this.hasMeeting = true
        }
        this.$nextTick(function () {
          this.openLoading().close()
          this.meetingListLoading = false
        })
      }).catch(err => {
        return err
      })
    },
    onShowWXCode: function (row) {
      this.MeetingCodeUrl = []
      this.MeetingCodeUrl.push(row.MeetingWXCodeUrl)
      this.MeetingCodeUrl.push(row.MeetingCodeUrl)
      this.showCode = true
    },
    onShowCode: function (row) {
      this.MeetingCodeUrl = []
      this.MeetingCodeUrl.push(row.MeetingCodeUrl)
      this.MeetingCodeUrl.push(row.MeetingWXCodeUrl)
      this.showCode = true
    },
    // 关闭查看器
    closeCode: function () {
      this.showCode = false
    },
    getIntoItemClick: function (row) {
      if (row.MeetingType === 0) {
        if (row.IsOnlyInvoice) {
          this.$router.push({ name: 'invoiceManager', params: { mid: row.MeetingID } })
        } else if (row.IsMeetingReceipt) {
          this.$router.push({ name: 'meetingReceipt', params: { mid: row.MeetingID } })
        } else {
          if (row.VoteNum > 0) {
            this.$router.push({ name: 'meetingVote', params: { mid: row.MeetingID } })
          } else {
            this.$router.push({ name: 'createVote', params: { mid: row.MeetingID, vid: '0', qid: '0' } })
          }
        }
      } else if (row.MeetingType === 2) {
        this.openLoading()
        voteManageApi.getVoteList({
          meetingId: row.MeetingID,
          skipCount: 0,
          maxResultCount: 10
        }).then(data => {
          this.$router.push({ name: 'editPublicVote', params: { mid: row.MeetingID, vid: data.Items[0].Id } })
          this.openLoading().close()
        }).catch(err => {
          this.openLoading().close()
          return err
        })
      } else {
        this.$router.push({ name: 'questionnaireManage', params: { mid: row.MeetingID } })
      }
    },
    openEditVote: function (meetingID) {
      this.$router.push({ name: 'meetingBasic', params: { mid: meetingID } })
    },
    meetingPublish: function (index, row) {
      this.$confirm('该操作将发布' + row.MeetingTypeText + '“' + row.MeetingName + '”，是否继续？', '提示-发布' + row.MeetingTypeText, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'custom_message_box'
      }).then(() => {
        this.openLoading()
        this.$api.meetingManage.meetingPublish(row.MeetingID).then(data => {
          //   this.makeMeetingInfo(data)
          //   this.meetingTableData.splice(index, 1, data)
          this.getMeetingList()
          this.refreshMainHeadMeetingList()
          this.$message({
            showClose: true,
            type: 'success',
            message: row.MeetingTypeText + '发布成功！',
            customClass: 'custom_message'
          })
          // this.openLoading().close()
        }).catch(err => {
          this.openLoading().close()
          return err
        })
      }).catch(() => {
        this.$message({
          showClose: true,
          type: 'info',
          message: '已取消发布' + row.MeetingTypeText,
          customClass: 'custom_message'
        })
      })
    },
    meetingCloseRelease: function (index, row) {
      this.$confirm('该操作将结束' + row.MeetingTypeText + '“' + row.MeetingName + '”，是否继续？', '提示-结束' + row.MeetingTypeText, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'custom_message_box'
      }).then(() => {
        this.openLoading()
        this.$api.meetingManage.meetingCloseRelease(row.MeetingID).then(data => {
          //   this.makeMeetingInfo(data)
          //   this.meetingTableData.splice(index, 1, data)
          this.getMeetingList()
          this.refreshMainHeadMeetingList()
          this.$message({
            showClose: true,
            type: 'success',
            message: row.MeetingTypeText + '已结束！',
            customClass: 'custom_message'
          })
          // this.openLoading().close()
        }).catch(err => {
          this.openLoading().close()
          return err
        })
      }).catch(() => {
        this.$message({
          showClose: true,
          type: 'info',
          message: '已取消结束' + row.MeetingTypeText,
          customClass: 'custom_message'
        })
      })
    },
    meetingClose: function (index, row) {
      this.$confirm('该操作将归档' + row.MeetingTypeText + '“' + row.MeetingName + '”，是否继续？', '提示-归档' + row.MeetingTypeText, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'custom_message_box'
      }).then(() => {
        this.openLoading()
        this.$api.meetingManage.meetingClose(row.MeetingID).then(data => {
          //   this.makeMeetingInfo(data)
          //   this.meetingTableData.splice(index, 1, data)
          this.getMeetingList()
          this.refreshMainHeadMeetingList()
          this.$message({
            showClose: true,
            type: 'success',
            message: row.MeetingTypeText + '已归档！',
            customClass: 'custom_message'
          })
          // this.openLoading().close()
        }).catch(err => {
          this.openLoading().close()
          return err
        })
      }).catch(() => {
        this.$message({
          showClose: true,
          type: 'info',
          message: '已取消归档' + row.MeetingTypeText,
          customClass: 'custom_message'
        })
      })
    },
    deleteMeeting: function (index, row) {
      this.$confirm('该操作将删除' + row.MeetingTypeText + '“' + row.MeetingName + '”，是否继续？', '提示-删除' + row.MeetingTypeText, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'custom_message_box'
      }).then(() => {
        this.openLoading()
        this.$api.meetingManage.deleteMeeting({ meetingId: row.MeetingID })
          .then(data => {
            // this.meetingTableData.splice(index, 1)
            this.getMeetingList()
            this.refreshMainHeadMeetingList()
            this.$message({
              showClose: true,
              type: 'success',
              message: row.MeetingTypeText + '已删除！',
              customClass: 'custom_message'
            })
            // this.openLoading().close()
          }).catch(err => {
            this.openLoading().close()
            return err
          })
      }).catch(() => {
        this.$message({
          showClose: true,
          type: 'info',
          message: '已取消删除' + row.MeetingTypeText,
          customClass: 'custom_message'
        })
      })
    },
    openCreateMeetingModal: function (key) {
      if (key === -1) {
        this.isShowCreateFrom = false
        this.typeTitle = '会议/活动'
        if (this.$config.enableVote && this.$config.enableWJ) {
          this.openCreateMeetingModal(0)
        }
        if (this.$config.enableVote && !this.$config.enableWJ) {
          this.openCreateMeetingModal(0)
        }
        if (!this.$config.enableVote && this.$config.enableWJ) {
          this.openCreateMeetingModal(1)
        }
      } else {
        this.dialogCreateVisible = true
        this.openLoading()
        this.isShowCreateFrom = true
        if (key === 0) {
          this.typeTitle = '会议'
        }
        if (key === 1) {
          this.typeTitle = '考试问卷'
        }
        if (key === 2) {
          this.typeTitle = '活动投票'
        }
        this.createMeetingForm.StartTime = new Date(this.$moment(new Date()).format('yyyy-MM-DD ') + '09:00')
        this.createMeetingForm.EndTime = new Date(this.$moment(new Date()).format('yyyy-MM-DD ') + '18:00')
        this.createMeetingForm.ApplyDeadlineTime = new Date(this.$moment(new Date()).format('yyyy-MM-DD ') + '18:00')
        this.createMeetingForm.MeetingType = key
        this.openLoading().close()
      }

      // this.getMeetingTypes()
    },
    meetingTypeChange: function () {
      if (this.createMeetingForm.MeetingType === 0) {
        this.typeTitle = '会议'
      }
      if (this.createMeetingForm.MeetingType === 2) {
        this.typeTitle = '活动投票'
        this.createMeetingForm.Verify = true
      }
      if (this.createMeetingForm.MeetingType === 1) {
        this.typeTitle = '考试问卷'
      }
    },
    // getMeetingTypes: function () {
    //   this.$api.dictionary.getDictionarys({
    //     parent: 1
    //   }).then(data => {
    //     this.meetingTypes = data
    //     if (!this.createMeetingForm.MeetingType) {
    //       this.createMeetingForm.MeetingType = this.meetingTypes[0].DictionaryID
    //     }
    //     this.openLoading().close()
    //   }).catch(err => {
    //     this.openLoading().close()
    //     return err
    //   })
    // },
    getCurrentUserRole: function () {
      this.$api.userInfo.getCurrentUserRole().then(data => {
        this.userRole = data
      }).catch(err => {
        return err
      })
    },
    addMeeting: function (formName) {
      this.openLoading()
      this.$refs[formName].validate((valid, object) => {
        if (valid) {
          //   if (this.createMeetingForm.TipsContent) {
          //     if (this.createMeetingForm.TipsContent.indexOf('ql-indent-1') !== -1) {
          //       this.createMeetingForm.TipsContent = this.createMeetingForm.TipsContent + '<style lang="less">.ql-indent-1{padding-left:2em;}</style>'
          //     }
          //     if (this.createMeetingForm.TipsContent.indexOf('ql-indent-2') !== -1) {
          //       this.createMeetingForm.TipsContent = this.createMeetingForm.TipsContent + '<style lang="less">.ql-indent-2{padding-left:4em;}</style>'
          //     }
          //     if (this.createMeetingForm.TipsContent.indexOf('ql-indent-3') !== -1) {
          //       this.createMeetingForm.TipsContent = this.createMeetingForm.TipsContent + '<style lang="less">.ql-indent-3{padding-left:6em;}</style>'
          //     }
          //     if (this.createMeetingForm.TipsContent.indexOf('ql-indent-4') !== -1) {
          //       this.createMeetingForm.TipsContent = this.createMeetingForm.TipsContent + '<style lang="less">.ql-indent-4{padding-left:8em;}</style>'
          //     }
          //     if (this.createMeetingForm.TipsContent.indexOf('ql-indent-5') !== -1) {
          //       this.createMeetingForm.TipsContent = this.createMeetingForm.TipsContent + '<style lang="less">.ql-indent-5{padding-left:10em;}</style>'
          //     }
          //   }
          this.$api.meetingManage.addMeeting({
            MeetingName: this.createMeetingForm.MeetingName,
            StartTime: this.$moment(this.createMeetingForm.StartTime).format('yyyy-MM-DD HH:mm'),
            EndTime: this.$moment(this.createMeetingForm.EndTime).format('yyyy-MM-DD HH:mm'),
            MeetingType: this.createMeetingForm.MeetingType,
            Address: this.createMeetingForm.Address,
            Contents: this.createMeetingForm.Contents,
            State: this.createMeetingForm.State,
            IsVoteUserApply: this.createMeetingForm.IsVoteUserApply,
            ApplyDeadlineTime: this.$moment(this.createMeetingForm.ApplyDeadlineTime).format('yyyy-MM-DD HH:mm'),
            IsGoApply: this.createMeetingForm.IsGoApply,
            ApplyButtonText: this.createMeetingForm.ApplyButtonText,
            TipsTitle: this.createMeetingForm.TipsTitle,
            TipsContent: this.createMeetingForm.TipsContent,
            Verify: this.createMeetingForm.Verify,
            IsEveryDay: this.createMeetingForm.IsEveryDay,
            IsAllowTrack: this.createMeetingForm.IsAllowTrack,
            ContactPeople: this.createMeetingForm.ContactPeople,
            ContactPhone: this.createMeetingForm.ContactPhone,
            IsOnlyInvoice: this.createMeetingForm.IsOnlyInvoice,
            IsMeetingReceipt: this.createMeetingForm.IsMeetingReceipt,
            MeetingReceiptState: this.createMeetingForm.MeetingReceiptState
          }).then(data => {
            // this.makeMeetingInfo(data)
            // if (this.hasMeeting) {
            //   this.meetingTableData.unshift(data)
            // }
            this.getMeetingList()
            this.createMeetingForm = {
              MeetingName: '',
              StartTime: new Date(this.$moment(new Date()).format('yyyy-MM-DD ') + '09:00'),
              EndTime: new Date(this.$moment(new Date()).format('yyyy-MM-DD ') + '18:00'),
              MeetingType: null,
              Address: '',
              Contents: '',
              State: 4,
              IsVoteUserApply: false,
              ApplyDeadlineTime: new Date(this.$moment(new Date()).format('yyyy-MM-DD ') + '18:00'),
              IsGoApply: false,
              Verify: false,
              IsEveryDay: false,
              IsAllowTrack: false,
              ContactPeople: '',
              ContactPhone: '',
              IsOnlyInvoice: false,
              IsMeetingReceipt: false,
              MeetingReceiptState: 0
            }
            this.dialogCreateVisible = false
            this.hasMeeting = true
            this.refreshMainHeadMeetingList()
            this.$message({
              showClose: true,
              type: 'success',
              message: '创建成功!',
              customClass: 'custom_message'
            })
          }).catch(err => {
            this.openLoading().close()
            return err
          })
        } else {
          for (const i in object) {
            let dom = this.$refs[i]
            if (Object.prototype.toString.call(dom) !== '[object Object]') {
              dom = dom[0]
            }
            dom.$el.scrollIntoView({
              block: 'center',
              behavior: 'smooth'
            })
            break
          }
          this.openLoading().close()
          return false
        }
      })
    },
    meetingVerifyChange: function () {
      const _this = this
      if (_this.createMeetingForm.Verify) {
        _this.createMeetingForm.IsEveryDay = true
      } else {
        _this.createMeetingForm.IsEveryDay = false
      }
    },
    refreshMainHeadMeetingList () {
      this.mainHeadGetMeetingList()
    },
    handleSizeChange (val) {
      this.meetingListQuery.maxResultCount = val
      this.$emit('changePaging', this.meetingListQuery.skipCount, this.meetingListQuery.maxResultCount, this.currentPage)
      this.getMeetingList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.meetingListQuery.skipCount = (val - 1) * this.meetingListQuery.maxResultCount
      this.$emit('changePaging', this.meetingListQuery.skipCount, this.meetingListQuery.maxResultCount, this.currentPage)
      this.getMeetingList()
    }
    // // 准备编辑器
    // onEditorReady (editor) {
    //   addQuillTitle()
    // },
    // // 失去焦点事件
    // onEditorBlur () { },
    // // 获得焦点事件
    // onEditorFocus (val, editor) {
    //   // window.console.log(val) // 富文本获得焦点时的内容
    //   // editor.enable(false) // 在获取焦点的时候禁用
    // },
    // // 内容改变事件
    // onEditorChange () { }
  },
  computed: {

  },
  mounted () {
    // const fontSizeStyle = Quill.import('attributors/style/size')
    // fontSizeStyle.whitelist = ['12px', '14px', '16px', '20px', '24px', '36px']
    // Quill.register(fontSizeStyle, true)

    // const alignStyle = Quill.import('attributors/style/align')
    // alignStyle.whitelist = ['right', 'center', 'justify']
    // Quill.register(alignStyle, true)

    // const fontStyle = Quill.import('attributors/style/font')
    // fontStyle.whitelist = ['sans serif', 'SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial']
    // Quill.register(fontStyle, true)

    // const directionStyle = Quill.import('attributors/style/direction')
    // Quill.register(directionStyle, true)
  },
  created () {
    if (this.$store.state.isLogin) {
      this.meetingListLoading = true
      this.openLoading()
      this.getMeetingList()
      this.getCurrentUserRole()
    } else {
      this.isInit = true
    }
    if (this.$route.params.isCreate) {
      this.openCreateMeetingModal(-1)
    }
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
      this.tableHeight = window.innerHeight - 255
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
      this.tableHeight = window.innerHeight - 205
    }
  }
}
</script>
<style lang="less">
.meeting_box .el-dialog__body {
  padding: 0px 20px;
}
// .quill-editor {
//   height: 150px;
// }
// .quill-editor .ql-container {
//   min-height: 170px;
// }
// /*
// 这里一定要写上，是用来把相关改变的配置在工具栏正常显示
// 如果不写，字体样式的下拉会重复显示Sans Serif，字体大小的下拉会重复显示Normal
// */
// .quill-editor .ql-picker.ql-font .ql-picker-label[data-value='SimSun']::before,
// .quill-editor .ql-picker.ql-font .ql-picker-item[data-value='SimSun']::before {
//   content: '宋体';
//   font-family: 'SimSun' !important;
// }
// .quill-editor .ql-picker.ql-font .ql-picker-label[data-value='SimHei']::before,
// .quill-editor .ql-picker.ql-font .ql-picker-item[data-value='SimHei']::before {
//   content: '黑体';
//   font-family: 'SimHei';
// }
// .quill-editor
//   .ql-picker.ql-font
//   .ql-picker-label[data-value='Microsoft-YaHei']::before,
// .quill-editor
//   .ql-picker.ql-font
//   .ql-picker-item[data-value='Microsoft-YaHei']::before {
//   content: '微软雅黑';
//   font-family: 'Microsoft YaHei';
// }
// .quill-editor .ql-picker.ql-font .ql-picker-label[data-value='KaiTi']::before,
// .quill-editor .ql-picker.ql-font .ql-picker-item[data-value='KaiTi']::before {
//   content: '楷体';
//   font-family: 'KaiTi' !important;
// }
// .quill-editor
//   .ql-picker.ql-font
//   .ql-picker-label[data-value='FangSong']::before,
// .quill-editor
//   .ql-picker.ql-font
//   .ql-picker-item[data-value='FangSong']::before {
//   content: '仿宋';
//   font-family: 'FangSong';
// }
// .quill-editor .ql-picker.ql-font .ql-picker-label[data-value='Arial']::before,
// .quill-editor .ql-picker.ql-font .ql-picker-item[data-value='Arial']::before {
//   content: 'Arial';
//   font-family: 'Arial';
// }

// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-label[data-value='12px']::before,
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-item[data-value='12px']::before {
//   content: '12px';
// }
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-label[data-value='14px']::before,
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-item[data-value='14px']::before {
//   content: '14px';
// }
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-label[data-value='16px']::before,
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-item[data-value='16px']::before {
//   content: '16px';
// }
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-label[data-value='20px']::before,
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-item[data-value='20px']::before {
//   content: '20px';
// }
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-label[data-value='24px']::before,
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-item[data-value='24px']::before {
//   content: '24px';
// }
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-label[data-value='36px']::before,
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-item[data-value='36px']::before {
//   content: '36px';
// }
// .ql-editor .ql-indent-1:not(.ql-direction-rtl) {
//   padding-left: 2em;
// }
// .ql-editor .ql-indent-2:not(.ql-direction-rtl) {
//   padding-left: 4em;
// }
// .ql-editor .ql-indent-3:not(.ql-direction-rtl) {
//   padding-left: 6em;
// }
// .ql-editor .ql-indent-4:not(.ql-direction-rtl) {
//   padding-left: 8em;
// }
// .ql-editor .ql-indent-5:not(.ql-direction-rtl) {
//   padding-left: 10em;
// }
</style>
